module.exports = __webpack_public_path__ + "img/diamond.cc60a390.png";